<template>
  <div>
    <excise-transactions listObject="nonExcise" :objectId="nonExciseId"
                         :back="[{text:'Non-excises',to:{name:'AlcoholNonExcises'}}]"
                          :contents="false" vessel/>
  </div>
</template>

<script>
import ExciseTransactions from '@/components/ExciseTransactions'

export default {
  name: 'AlcoholNonExcisesTransactions',
  components: {ExciseTransactions},
  props: {
    nonExciseId: {type:String, required:true}
  }
}
</script>